"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityNetworkQuery = void 0;
var client_1 = require("@apollo/client");
var entityNetworkQuery = function (definition, context) {
  var _a = context.queryName,
    queryName = _a === void 0 ? '' : _a,
    _b = context.queryFields,
    queryFields = _b === void 0 ? '' : _b,
    entities = context.entities;
  return !queryName && definition.network.query || (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query ", "($input: GraphInput) {\n      all", " {\n        id name slug sid\n        openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } }\n        graph(input: $input) {\n          nodes { id label color image { id url width height } openGraph { title url description { id text } image { id url } } data { level group { id entityTypeName label } entityTypeName entitySlug entityId } }\n          edges { id id1 id2 isImplicit label data { type } }\n        }\n        ", "\n        ", "\n      }\n    }\n  "], ["\n    query ", "($input: GraphInput) {\n      all", " {\n        id name slug sid\n        openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } }\n        graph(input: $input) {\n          nodes { id label color image { id url width height } openGraph { title url description { id text } image { id url } } data { level group { id entityTypeName label } entityTypeName entitySlug entityId } }\n          edges { id id1 id2 isImplicit label data { type } }\n        }\n        ", "\n        ", "\n      }\n    }\n  "])), queryName || "".concat(definition.typeName, "NetworkQuery"), definition.pluralTypeName, queryFields || definition.network.queryFields || '', definition.banner.queryFields || '');
};
exports.entityNetworkQuery = entityNetworkQuery;
var templateObject_1;